import React from 'react';
import DeleteConfirmationModal from '../components/DeleteConfirmationModal';

const ConfirmationModals = ({
  deleteImageModalOpen,
  setDeleteImageModalOpen,
  confirmDeleteVariantImage,
  deleteVariantModalOpen,
  setDeleteVariantModalOpen,
  confirmDeleteVariant,
}) => {
  return (
    <>
      {/* Confirmation modal for deleting variant images */}
      <DeleteConfirmationModal
        isOpen={deleteImageModalOpen}
        onClose={() => setDeleteImageModalOpen(false)}
        onConfirm={confirmDeleteVariantImage}
        title="Supprimer l'image"
        message="Êtes-vous sûr de vouloir supprimer cette image? Cette action est irréversible."
      />

      {/* Confirmation modal for deleting variants */}
      <DeleteConfirmationModal
        isOpen={deleteVariantModalOpen}
        onClose={() => setDeleteVariantModalOpen(false)}
        onConfirm={confirmDeleteVariant}
        title="Supprimer la variante"
        message="Êtes-vous sûr de vouloir supprimer cette variante? Cette action est irréversible."
      />
    </>
  );
};

export default ConfirmationModals;